import axios from 'axios'
import UserService from '@/services/UserService'

const InviteService = {
  async referralSummary (data) {
    await UserService.authHeader()
    return axios({
      url: UserService.baseUrl() + 'invite/admin/referralsummary/',
      method: 'post',
      data: JSON.stringify({
        startDate: data.startDate,
        endDate: data.endDate,
        search: data.search
      })
    })
  },
}

export default InviteService
